<template>
    <div class="custList">
        <div class="screenBox">
            <!-- 输入客户名称/联系人/电话/手机/邮箱/网址/域名 -->
            <search-bar v-model="keywords" @keyup.enter.native="getListDatas" @btnClick="getListDatas" :placeholder="$t('mx_mobile.Client.1627021420846')"></search-bar>
        </div>
        <div style="height:1px"></div>
        <div class="moduleCodePage">
            <scroll class="wrapper" ref="scroll" :pullDownRefresh="pullDownRefreshObj" :pullUpLoad="pullUpLoadObj" :startY="parseInt(startY)" @pullingDown="onPullingDown" @pullingUp="onPullingUp">
                <!-- <div class="list ellipsis" v-for="(item, index) in listData" :key="index">
              {{item.custName}}
          </div> -->
                <van-cell-group>
                    <van-cell v-for="(item, index) in listData" :key="index" :value="item.custName" @click="$emit('submitItem', item)" />
                </van-cell-group>
            </scroll>
        </div>
    </div>
</template>
<script>
import Scrolls from '@/components/Scroll/index'
import SearchBars from '@/page/Document/Vue/SearchBar/index'
export default {
    name: 'custList',
    data() {
        return {
            pullDownRefresh: true,
            pullDownRefreshThreshold: 60,
            pullDownRefreshStop: 60,
            pullUpLoad: true,
            pullUpLoadThreshold: 0,
            pullUpLoadMoreTxt: this.$t('mx_mobile.Client.1585271749707'), // 加载更多
            pullUpLoadNoMoreTxt: this.$t('mx_mobile.Client.1585271760385'), // 没有更多数据了
            startY: 0,
            scrollToX: 0,
            scrollToY: -200,
            scrollToTime: 700,
            scrollToEasing: 'bounce',
            scrollToEasingOptions: ['bounce', 'swipe', 'swipeBounce'],

            msg: 'custList',
            listData: [],
            keywords: '',
            sort: 'createDate',
            page: {
                total: 0,
                from: 0,
                size: 20
            }
        }
    },
    created() {
        this.pageUrl = this.$route.path
        this.unit()
    },
    computed: {
        pullDownRefreshObj: function () {
            return this.pullDownRefresh ? {
                threshold: parseInt(this.pullDownRefreshThreshold),
                stop: parseInt(this.pullDownRefreshStop)
            } : false
        },
        pullUpLoadObj: function () {
            return this.pullUpLoad ? {
                threshold: parseInt(this.pullUpLoadThreshold),
                txt: { more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt }
            } : false
        }
    },
    mounted() {
    },
    methods: {
        async getListDatas() {
            let obj = {
                keywords: this.keywords
            }
            this.page = {
                total: 0,
                from: 0,
                size: 20
            }
            this.listData = await this.getListData(obj)
        },
        async sortSeachClick(fieldName) {
            this.sort = fieldName
            this.listData = await this.getListData()
        },
        async getListData(obj) {
            let data = {
                moduleCode: 'BF001',
                order: 'desc',
                from: this.page.from,
                size: this.page.size,
                sort: this.sort,
                searchType: 'allList'
            }
            if (obj) {
                data = Object.assign(data, obj)
            }
            let res = await this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.document_generalOperate_get, { params: data })
            if (res.data.code.toString() === this.Global.config.RES_OK) {
                this.page.total = res.data.data.totalNum
                return res.data.data.list
            } else {
                this.$toast.fail(res.data.msg)
                return []
            }
        },
        unit() {
            let _this = this
            var p1 = new Promise((resolve, reject) => {
                let data = {
                    moduleCode: 'BF001',
                    order: 'desc',
                    from: this.page.from,
                    size: this.page.size,
                    sort: this.sort,
                    searchType: 'allList'
                }
                this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.document_generalOperate_get, { params: data }).then((res) => {
                    if (res.data.code.toString() === this.Global.config.RES_OK) {
                        resolve(res.data.data.list)
                        this.page.total = res.data.data.totalNum
                    } else {
                        this.$toast.fail(res.data.msg)
                    }
                }, function (res) {
                    this.$toast.fail(this.Global.config.errorTitle)
                })
            })
            Promise.all([p1]).then(function (results) {
                _this.listData = results[0]
            })
        },
        async onPullingDown() {
            this.page.from = 0
            this.listData = await this.getListData()
            this.$nextTick(() => {
                this.$refs.scroll.forceUpdate()
            })
        },
        async onPullingUp() {
            if (this.listData.length >= this.page.total) {
                this.$refs.scroll.forceUpdate(false)
                return
            }
            if (this.listData.length < this.page.total) {
                this.page.from += 10
                let listData = await this.getListData()
                this.listData = this.listData.concat(listData)
                this.$nextTick(() => {
                    if (this.listData.length >= this.page.total) {
                        this.$refs.scroll.forceUpdate(false)
                    } else {
                        this.$refs.scroll.forceUpdate(true)
                    }
                })
            }
        },
        rebuildScroll() {
            this.$nextTick(() => {
                this.$refs.scroll.destroy()
                this.$refs.scroll.initScroll()
            })
        }
    },
    watch: {
        pullDownRefreshObj: {
            handler(val) {
                const scroll = this.$refs.scroll.scroll
                if (val) {
                    scroll.openPullDown()
                } else {
                    scroll.closePullDown()
                }
            },
            deep: true
        },
        pullUpLoadObj: {
            handler(val) {
                const scroll = this.$refs.scroll.scroll
                if (val) {
                    scroll.openPullUp()
                } else {
                    scroll.closePullUp()
                }
            },
            deep: true
        },
        startY() {
            this.rebuildScroll()
        }
    },
    components: {
        'Scroll': Scrolls,
        'search-bar': SearchBars
    }
}
</script>

<style lang="less" scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
